import { type Feature } from 'ol';
import {
  type MapCadastralAreaItem,
  type MapIntersectionItem,
} from '../../../createMapSchema.ts';
import { geoJSONEpsg3857 } from '../../../mapStyleUtils.ts';

/** Parametri per la costruzione di un item di intersezione custom. */
export interface IBuildCustomItemInput {
  intersectable: Feature;
  intersectionFeature: Feature;
  area: number;
  drawnFeature: Feature;
  attributes: string[];
}

/**
 * Costruisce un item catastale a partire dalla feature di intersezione
 * (SEZIONE, NUMERO, COMUNE, FOGLIO).
 */
export function buildCadastralItem(
  intersectable: Feature,
  intersectionFeature: Feature,
  area: number,
  drawnFeature: Feature,
): MapCadastralAreaItem {
  const props = intersectable.getProperties();
  return {
    area,
    isManual: false,
    cadastralSection: props?.SEZIONE,
    cadastralParticle: props?.NUMERO,
    castralMunicipality: props?.COMUNE,
    cadastralSheet: props?.FOGLIO,
    feature: geoJSONEpsg3857.writeFeature(intersectionFeature),
    affectedArea: area,
    sourceGeometryIndex: drawnFeature.get('geometryIndex') as
      | number
      | undefined,
  };
}

/**
 * Costruisce un item di intersezione custom estraendo
 * gli attributi configurati dalle proprietà della feature.
 */
export function buildCustomIntersectionItem(
  input: IBuildCustomItemInput,
): MapIntersectionItem {
  const { intersectable, intersectionFeature, area, drawnFeature, attributes } =
    input;
  const props = intersectable.getProperties();
  const extractedAttributes: Record<string, string> = {};
  for (const attr of attributes) {
    extractedAttributes[attr] =
      props?.[attr] != null ? String(props[attr]) : '';
  }
  return {
    isManual: false,
    attributes: extractedAttributes,
    feature: geoJSONEpsg3857.writeFeature(intersectionFeature),
    area,
    affectedArea: area,
    sourceGeometryIndex: drawnFeature.get('geometryIndex') as
      | number
      | undefined,
  };
}
